/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
// libraries
import React, {useCallback, useState, useEffect } from 'react';
// material
import { SingleSelectDropDown } from '@insticator/insticator-ui';
// redux
import {useSelector, useDispatch} from 'react-redux';
// components
import Header from "../../../material/structure/header/header";
import {updateSelectedSite} from "../../../state/thunks/session";
// styles
import injectSheet from 'react-jss';
import styles from "./engagement_styles";
import { updateCurrentPage } from 'state/slices/app';

const EngagementHeader = injectSheet(styles)((props) => {
  const dispatch = useDispatch();
  const {
    account: {
      sites = {}
    },
    session: {
      siteUUID,
    },
    engagement: {
      emojiConfigurations
    },
    migrationStatus: {
      sitesWithProductsV2
    },
    app: {
      currentPage
    }
  } = useSelector((state) => state);

  const [selectedSite, selectSite] = useState(siteUUID)

  useEffect(() => {
    selectSite(emojiConfigurations.siteUUID)
  }, [emojiConfigurations])

  const handleSelectSite = useCallback(opt =>{
      dispatch(updateSelectedSite(opt.value));
      selectSite(opt.value)
      if(currentPage.includes('dashboard/trendsandreactions/')) {
        // if current site has 2.0 redirect to commenting configuration
        if(sitesWithProductsV2.includes(opt.value)) dispatch(updateCurrentPage('/dashboard/commenting/configuration'))
      }
  }, [dispatch]);

  return (
    <Header>
      {/* <div
        className="field type-select isActive-false disabled-undefined isValid-undefined hasValue-false Field-field Field-field">
        <div className={props.classes.SelectWrapper}>
          <i className="fas fa-sort-down "></i>
          <select
            onChange={handleSelectSite}
            className={props.classes.SelectField}
            value={siteUUID || ''}
            type="text">
          {Object.keys(sites).map(key =>
            <option key={key} value={key}>{sites[key]}</option>)}
        </select>
        </div>
      </div> */}
    { sites &&  emojiConfigurations.siteUUID &&
        <SingleSelectDropDown 
          name={sites[selectedSite]} 
          title={'Domain'} 
          icon={'globe'} 
          searchable={false} 
          onSelect={handleSelectSite} 
          items={Object.keys(sites).map(key => ({ name: sites[key], value: key, dir: 'ASC' }))}
        />
    }
    </Header>
  )
});

export default EngagementHeader;
